import wxLogin from './wechat/wechat-login'
import router from '../router'
import wxData from './wechat/wechat-param'
import utils from '../jslib/utils'
import wxShare from './wechat/wechat-share'

//判断当前浏览器环境
var ua = navigator.userAgent.toLowerCase();

router.beforeEach((to, from, next) => {
  console.log(to, '触发路由卫士_to');

  //修改标题
  utils.changeTitle(to.meta.title)
  if (utils.getHashUrlParams('convenienceNo') && utils.getHashUrlParams('regionCode')) {
    sessionStorage.setItem('convenienceNo', utils.getHashUrlParams('convenienceNo'))
    sessionStorage.setItem('regionCode', utils.getHashUrlParams('regionCode'))
    // this.convenienceNo = this.$utils.getHashUrlParams('convenienceNo')
  }

  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    console.log('微信浏览器')
    next();
  } else {
    console.log('外置浏览器');
    next();
  }


})
router.afterEach((to, from, next) => {

  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    console.log('微信浏览器')
    // wxShare(wxData)
  } else {
    console.log('外置浏览器');
  }

})



// WEBPACK FOOTER //
// ./src/jslib/router-intercept.js